import { Component, inject, signal } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Observable } from 'rxjs'
import { StaffService } from 'src/app/core/services/staff/staff.service'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { StaffTableComponent } from 'src/app/shared/components/staff/staff-list/staff-table.component'
import { StaffListItem } from 'src/app/shared/interfaces/staff/staff-list-item.interface'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { StaffSearchComponent } from '../components/staff-search/staff-search.component'
import { StaffFilter } from 'src/app/shared/interfaces/staff/staff-filter.interface'
import { rxResource } from '@angular/core/rxjs-interop'
import { PageActionBarComponent } from 'src/app/shared/components/page-action-bar/page-action-bar.component'
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service'
import { ToastrService } from 'ngx-toastr'

@Component({
    selector: 'sf-staff-list',
    imports: [
        RouterModule,
        NgbPaginationModule,
        PageActionBarComponent,
        ButtonComponent,
        StaffTableComponent,
        StaffSearchComponent,
        CardComponent,
        ButtonComponent,
    ],
    templateUrl: './staff-list.component.html',
    styleUrls: ['./staff-list.component.scss'],
})
export class StaffListComponent {
    #staffService = inject(StaffService)
    #confirmationService = inject(ConfirmationDialogService)
    #toastr = inject(ToastrService)

    filter = signal<StaffFilter>({ pageNumber: 1, pageSize: 20 })

    staff$!: Observable<PaginatedList<StaffListItem>>

    #staffResource = rxResource({
        request: this.filter,
        loader: ({ request }) => this.#staffService.getStaffPaged(request),
    })

    staff = this.#staffResource.value

    pageChanged(page: number): void {
        this.filter.update((x) => ({ ...x, pageNumber: page }))
    }

    filterChanged(filter: StaffFilter): void {
        this.filter.update((x) => ({ ...x, ...filter }))
    }

    unlockStaffAccount(staffId: number): void {
        this.#confirmationService
            .confirm('Are you sure?', 'Are you sure you want to unlock this staff account?')
            .then((result) => {
                if (result) {
                    this.#staffService.unlockStaffAccount(staffId).subscribe(() => {
                        this.#toastr.success('Staff account unlocked successfully')
                        this.#staffResource.reload()
                    })
                }
            })
    }
}
